import { useEffect } from 'react';

import Header from '@/components/dashboard/apiSdk/Header';
import IntegrationSection from '@/components/dashboard/apiSdk/IntegrationSection';
import JoinFutureSection from '@/components/dashboard/apiSdk/JoinFutureSection';
import VentureBackedArticle from '@/components/dashboard/home/new/VentureBackedArticle';
import { useTheme } from '@/hooks/useTheme';

const ApiSdk = () => {
  const { handleSetTheme } = useTheme();
  useEffect(() => {
    handleSetTheme('dark');
  }, [handleSetTheme]);
  return (
    <main className='min-h-screen'>
      <Header />
      <IntegrationSection />
      <VentureBackedArticle />
      <JoinFutureSection />
    </main>
  );
};

ApiSdk.hideSocialAndGas = true;
ApiSdk.disableMaxWidth = true;

ApiSdk.metadata = {
  title: 'NettyWorth | Launch a Loan Marketplace with NettyWorth’s API/SDK',
  description: 'With just a few lines of code, integrate peer-to-peer lending for NFTs, Gaming Assets, and Real-World Assets (RWAs) into your platform. Boost asset liquidity and increase revenue seamlessly.',
  image: `${process.env.NEXT_PUBLIC_SITE_URL}/thumbnail.png`,
  contentType: 'product',
};

export default ApiSdk;
